export const DISPATCH_ONLINE_WINDOW_MS = 90_000

export function isRecentlyOnline(assignment, nowMs = Date.now()) {
  const lastSeenMs = Date.parse(String(assignment?.last_seen_at || ''))
  return Number.isFinite(lastSeenMs) && Math.max(0, nowMs - lastSeenMs) <= DISPATCH_ONLINE_WINDOW_MS
}

export function buildExactDispatchScope({
  assignments = [],
  selectedIds = [],
  localDate,
  preferredPlatforms = ['xiaohongshu'],
}) {
  const selected = new Set(selectedIds.map((value) => String(value || '')).filter(Boolean))
  const platforms = preferredPlatforms.length ? preferredPlatforms : ['xiaohongshu']
  const targets = assignments
    .filter((item) => item?.status === 'active' && selected.has(String(item.id || '')))
    .map((item) => ({
      app_binding_id: String(item.id),
      platform: String(item.platform || platforms[0] || 'xiaohongshu'),
    }))
  return {
    local_date: localDate,
    dispatch_mode: 'manual',
    target_scope: 'exact_targets',
    max_tasks: Math.max(1, targets.length),
    preferred_platforms: platforms,
    targets,
  }
}
